<template>
  <component class="identity-component" :is="componentType"></component>
</template>

<script>
import { useIdentityStore } from '~/store/identity';
import { useRoute } from 'vue-router'
import { useRootStore } from '~/store/root'
import { useRouter } from 'vue-router'
import IdentityContactUs from '../../components/identity/ContactUs';
import IdentityForgotPasswordChallenge from '../../components/identity/ForgotPasswordChallenge';
import IdentityForgotPasswordVerify from '../../components/identity/ForgotPasswordVerify';
import IdentityLogin from '../../components/identity/Login';
import IdentityMfaEnroll from '../../components/identity/MfaEnroll';
import IdentityMfaEnrollActivate from '../../components/identity/MfaEnrollActivate';
import IdentityMfaVerify from '../../components/identity/MfaVerify';
import IdentityPasswordExpired from '../../components/identity/PasswordExpired';
import IdentityResetPassword from '../../components/identity/ResetPassword';
import IdentitySsnVerification from '../../components/identity/IdentitySsnVerification';

export default {
  name: 'Identity-Parent',
  components: {
    IdentityPasswordExpired,
    IdentityContactUs,
    IdentityForgotPasswordChallenge,
    IdentityForgotPasswordVerify,
    IdentityLogin,
    IdentityMfaEnroll,
    IdentityMfaEnrollActivate,
    IdentityMfaVerify,
    IdentityResetPassword,
    IdentitySsnVerification,
  },
  async setup() {
    definePageMeta({
      layout: 'identity',
    })
    const router = useRouter()
    const route = useRoute()
    const rootStore = useRootStore()
    const identityStore = useIdentityStore()
    if (rootStore.isLoggedIn) {
      await router.push('/resume-app')
    }
    const page = route.params?.component ?? 'login';
    const pageMap = {
      'password-expired': {
        component: 'IdentityPasswordExpired',
        title: 'Password Expired',
      },
      'contact': {
        component: 'IdentityContactUs',
        title: 'Contact',
      },
      'forgot-password': {
        component: 'IdentityForgotPasswordChallenge',
        title: 'Forgot Password',
      },
      'forgot-password-verify': {
        component: 'IdentityForgotPasswordVerify',
        title: 'Forgot Password',
      },
      'login': {
        component: 'IdentityLogin',
        title: 'Login',
      },
      'ssn-verification': {
        component: 'IdentitySsnVerification',
        title: 'SSN Verification',
      },
      'mfa-enroll': {
        component: 'IdentityMfaEnroll',
        title: 'MFA Enroll',
      },
      'mfa-enroll-activate': {
        component: 'IdentityMfaEnrollActivate',
        title: 'MFA Enroll',
      },
      'mfa-verify': {
        component: 'IdentityMfaVerify',
        title: 'MFA Verify',
      },
      'reset-password': {
        component: 'IdentityResetPassword',
        title: 'Reset Password',
      },
    }
    return {
      componentType: pageMap[page].component,
      title: pageMap[page].title,
      identityStore,
    }
  },
  async mounted() {
    document.title = 'Lendio - ' + this.title;
  },
}
</script>
